<template>
  <div class="horizontal-divider">
    <div class="divider-line" :class="dividerColor" />
    <div v-if="text" class="divider-text">{{ text }}</div>
    <div class="divider-line" :class="dividerColor" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  text: {
    type: String,
    default: '',
  },
  dividerColor: {
    type: String,
    default: 'tw-bg-secondary-bg-dark',
  },
});
</script>

<style>
.horizontal-divider {
  @apply tw-flex tw-justify-center tw-items-center;
}

.divider-line {
  @apply tw-h-[1px] tw-grow;
}

.divider-text {
  @apply tw-text-cool-grey-200 tw-ds-text-xs--medium tw-mx-3;
}
</style>
